
export const navPncItems = [
  {
    title: 'หน้าแรก',
    icon: 'la-home',
    page: '/pnc/booth-visit',

  },
  { section: 'APPS', icon: 'la-ellipsis-h' },
  {
    title: 'บันทึกข้อมูลใหม่',
    icon: 'la-calendar-check-o',
    page: '/pnc/booth-visit/add-school'
  },
  {
    title: 'ข้อมูลผู้เข้าชมบูท',
    icon: 'la-calendar-check-o',
    page: '/pnc/booth-visit/report-visit'
  },

  {
    title: 'ออกจากระบบ',
    icon: 'la-calendar-check-o',
    page: '/student/grade'
  },
  
];